import React from 'react';
import { Row, Col } from 'react-bootstrap';
import FormInput from '../../form/FormInput';

const StepAddress = ({ control, errors }) => (
    <div className="animate-fade-in">
        <div className="form-section-title">Address Details</div>
        <Row>
            <Col md={4}><FormInput name="addressLine1" label="Address Line 1" control={control} errors={errors}  /></Col> 
            <Col md={4}><FormInput name="state" label="State" control={control} errors={errors}  /></Col> 
            <Col md={4}><FormInput name="district" label="District" control={control} errors={errors}  /></Col> 
        </Row>
        <Row>
            <Col md={6}><FormInput name="pinCode" label="Pin Code" control={control} errors={errors}  /></Col>
            <Col md={6}><FormInput name="addressLine2" label="Address Line 2" control={control} errors={errors} /></Col> 
        </Row>
    </div>
);

export default StepAddress;